import Cookies from 'js-cookie';
// import modals from './modal';
import * as basicLightbox from 'basiclightbox';
import Mustache from 'mustache';

const lightbox = {
  template: null,
  content: null,
  element: null
};

const cookiePopup = (() => {
  const COOKIE = 'cookie_consent_zh';

  /**
   * Insert baidu analytics and hubspot
   *
   * @param {object} data - Datalayer data
   */
  function triggerScripts(data = {}) {
    Object.keys(data).forEach(key => {
      let dlData;
      if (key === 'deny_all') {
        dlData = {
          event: key,
          [key]: data[key],
          cookies_statistical_accepted: false,
          cookies_ad_accepted: false
        };
      } else if (key === 'cookies_all') {
        // "All" is special, needs cookie categories explicitly
        dlData = {
          event: key,
          [key + '_accepted']: data[key],
          cookies_statistical_accepted: true,
          cookies_ad_accepted: true
        };
      } else if (data[key]) {
        dlData = {
          event: key,
          [key + '_accepted']: data[key]
        };
      } else {
        dlData = {
          [key + '_accepted']: data[key]
        };
      }

      if (dlData) {
        if (dlData.cookies_statistical_accepted) {
          // Baidu script
          var _hmt = _hmt || [];
          (function() {
            var hm = document.createElement('script');
            hm.src = 'https://hm.baidu.com/hm.js?4e27e8272194ce03c77ea8e0696eb17f';
            var s = document.getElementsByTagName('script')[0];
            hm.classList.add('baidu-analytics-script');
            s.parentNode.insertBefore(hm, s);
          })();
        }
        if (dlData.cookies_ad_accepted) {
          // Hubspot script
          var hs = document.createElement('script');
          hs.src = 'https://js.hs-scripts.com/6463692.js';
          var s = document.getElementsByTagName('script')[0];
          hs.classList.add('hubspot-script');
          s.parentNode.insertBefore(hs, s);
        }
      }
    });
  }

  /**
   * Gets form field values as key-value pairs
   *
   * @param {HTMLElement} form - Form element
   *
   * @return {object}
   */
  function serialize(form) {
    const serialized = {};

    if (form) {
      let elements = Array.from(form.elements);
      elements.forEach(field => {
        if (field.name) {
          if (
            (field.type !== 'checkbox' && field.type !== 'radio') ||
            field.checked
          ) {
            serialized[field.name] = field.value;
          }
        }
      });
    }

    return serialized;
  }

  /**
   * Formats form data
   *
   * @param {object} data - Form data as key-value pairs
   *
   * @return {object} formattedData
   */
  function formatFormData(data) {
    const formattedData = { ...data };

    // Format to booleans
    Object.keys(formattedData).forEach(key => {
      formattedData[key] = formattedData[key] === '1';
    });

    return formattedData;
  }

  /**
   * Handles cookie form submit event
   * Triggers script inserts, closes modal, hides notice
   *
   * @param {Event} event - Submit event
   */
  function onSubmit(event) {
    event.preventDefault();
    const form = event.target;
    const formData = formatFormData(serialize(form));

    // Send values to tag manager
    triggerScripts(formData);

    // Save values to cookie
    setCookie(formData);

    // Close cookie popup, if open
    closePopup();

    // Also hide cookie notice
    hideCookieNotice();
  }

  /**
   * Approves all cookies,
   * triggers script insert event and saves settings to cookie,
   * closes modal (if open),
   * and hides cookie notice
   *
   * @param {HTMLElement} triggerBtn - "Approve all" button
   */
  function approveAll(triggerBtn) {
    const cookieValue = { cookies_all: true };

    // Send value to GTM
    triggerScripts(cookieValue);

    // Save value to cookie
    setCookie(cookieValue);

    // Close cookie popup, if open
    closePopup();

    // Also hide cookie notice
    hideCookieNotice();
  }

  /**
   * Denies all cookies,
   * triggers script insert event and saves settings to cookie,
   * closes modal (if open),
   * and hides cookie notice
   *
   * @param {HTMLElement} triggerBtn - "Approve all" button
   */
  function denyAll(triggerBtn) {
    const cookieValue = { deny_all: true };

    // Send value to GTM
    triggerScripts(cookieValue);

    // Save value to cookie
    setCookie(cookieValue);

    // Close cookie popup, if open
    closePopup();

    // Also hide cookie notice
    hideCookieNotice();
  }

  /**
   * Saves cookie consent data to a cookie
   *
   * @param {object} data - Cookie value (will be stringified)
   */
  function setCookie(data) {
    Cookies.set(COOKIE, JSON.stringify(data), { expires: 365 });
  }

  /**
   * Remove existing consent cookie
   */
  function removeCookie() {
    Cookies.remove(COOKIE);
  }

  /**
   * Closes cookie popup modal
   */
  function closePopup() {
    lightbox.element ? lightbox.element.close() : [];
  }

  /**
   * Hides cookie notice ribbon
   * by removing it from dom
   */
  function hideCookieNotice() {
    const notice = document.getElementById('cookie-notice');
    if (notice) {
      notice.parentNode.removeChild(notice);
    }
  }

  /**
   * Checks whether cookie consent has been given previously
   * and fires scripts insert immediately if consent found.
   */
  function checkExistingConsent() {
    const consentCookie = Cookies.get(COOKIE);

    if (consentCookie) {
      try {
        const cookieSettings = JSON.parse(consentCookie);
        triggerScripts(cookieSettings);
        // Delete element (proxy cache)
        hideCookieNotice();
      } catch (e) {
        // Cannot determine values. Do nothing.
      }
    }
  }

  /**
   * Inits cookie popup functionality.
   */
  function init() {
    // Add event listeners
    document.addEventListener(
      'click',
      function(event) {
        if (event.target.matches('.js-cookie-popup-approve-all')) {
          approveAll(event.target);
        }
      },
      false
    );

    document.addEventListener(
      'click',
      function(event) {
        if (event.target.matches('.js-cookie-popup-deny-all')) {
          denyAll(event.target);
        }
      },
      false
    );

    document.addEventListener(
      'click',
      function(event) {
        if (event.target.matches('.js-trigger-modal')) {
          lightbox.content = Mustache.render(document.querySelector('.js-template-cookie-consent-modal').innerHTML);
          lightbox.element = basicLightbox.create(lightbox.content);
          lightbox.element.show();
        }
      },
      false
    );

    document.addEventListener(
      'click',
      function(event) {
        if (event.target.matches('.js-close-modal')) {
          lightbox.element.close();
        }
      },
      false
    );

    document.addEventListener('submit', function(event) {
      if (event.target.matches('.js-cookie-popup-form')) {
        onSubmit(event);
      }
    });

    // Check existing cookie consent settings
    checkExistingConsent();

    // Show notice if needed
    const notice = document.getElementById('cookie-notice');
    if (notice) {
      notice.style.display = 'block';
    }
  }

  return {
    init,
    removeCookie
  };
})();

cookiePopup.init();

export default cookiePopup;
